<template>
  <div class="widget-config">
    <el-form
      label-suffix="："
      label-width="120px"
      label-position="left"
      v-if="this.data && Object.keys(this.data).length > 0"
      size="small"
    >
      <el-collapse v-model="collapse">
        <el-collapse-item name="1" title="基本属性">
          <el-form-item label="类型">
            <el-select
              v-model="data.type"
              placeholder="请选择类型"
              @change="handleChangeType"
            >
              <el-option-group
                v-for="group in fields"
                :key="group.title"
                :label="group.title"
              >
                <el-option
                  v-for="item in group.list"
                  :key="item.type"
                  :label="item.label"
                  :value="item.type"
                ></el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="数据类型">
            <el-select
              v-model="data.itemDataType"
              placeholder="请选择类型"
              @change="handleChangeDataType"
            >
              <el-option
                v-for="item in dataTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="数据表字段">
            <el-input v-model="tempComment" placeholder="请选择数据表字段" readonly @click.native="selectFieldId"></el-input>
            <el-input style="display:none;" v-model="data.fieldId" placeholder="请选择数据表字段" readonly @click.native="selectFieldId"></el-input>
            <div v-if="showFieldSelectList" style="position: absolute;
    z-index: 9999;
    background: #fff;
    border: 1px solid #ccc;width: 100%;">
              <ul id="fieldSelectList"
              >
                <li
                v-for="(item, index) in fieldsDataList"
                :key="index"
                :fieldid="item.id"
                :comment="item.comment"
                :unclick="item.disabled?1:0"
                @click.stop="handlerLiClick($event)"
                >
                
                <!-- :style="{cursor:item.disabled?'not-allowed':'default'}" -->
                <div 
                style="box-sizing:border-box;padding:0 .5rem;"
                :fieldid="item.id"
                :comment="item.comment"
                :unclick="item.disabled?1:0"
                @click.stop="handlerLiClick($event)"
                >{{item.comment}}</div>
                </li>
              </ul>
            </div>
            <div style="display:none;">{{getFieldLabel(data.fieldId)?getFieldLabel(data.fieldId):'暂无数据'}}</div>
            <!-- <el-select v-model="data.fieldId" @change="handlerSelectChange" @focus="handlerSelectFocus" @blur="handlerSelectBlur" placeholder="请选择">
              <el-option
                v-for="(item, index) in fieldsDataList"
                :key="index"
                :label="item.comment"
                :value="item.id"
                :disabled="item.disabled"
              ></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="属性值">
            <el-input v-model="data.prop" placeholder="属性值" maxlength="10"></el-input>
          </el-form-item>
          <el-form-item label="标题">
            <el-input v-model="data.label" placeholder="标题" maxlength="10"></el-input>
          </el-form-item>
          <el-form-item label="宽度" v-if="data.subfield">
            <el-input-number
              v-model="data.width"
              controls-position="right"
              placeholder="宽度"
              :min="100"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="内容" v-if="data.component == 'elDivider'">
            <el-input v-model="data.params.html" placeholder="内容"></el-input>
          </el-form-item>
          <!-- <el-form-item
            label="表单栅格（仅PC端生效）"
            v-if="!data.subfield && !['group'].includes(data.type)"
          >
            <el-input-number
              v-model="data.span"
              controls-position="right"
              placeholder="表单栅格"
              :min="8"
              :max="24"
            ></el-input-number>
          </el-form-item> -->
          <!-- <el-form-item
            label="数据类型"
            v-if="['cascader', 'checkbox', 'upload', 'img', 'array'].includes(data.type)"
          >
            <el-select v-model="data.dataType" placeholder="数据类型" clearable>
              <el-option label="String" value="string"></el-option>
              <el-option label="Number" value="number"></el-option>
            </el-select>&nbsp;
            <a href="https://avuejs.com/doc/dataType" target="_blank" style="color: #409eff;">详情</a>
            <br />
          </el-form-item> -->
          <!-- <el-form-item label="深结构">
            <a href="https://avuejs.com/doc/form/form-bind" target="_blank" style="color: #409eff;"
              >详情</a
            ><br />
            <el-input v-model="data.bind" placeholder="深结构"></el-input>
          </el-form-item>-->
          <div style="height: 10px; background: #000"></div>
          <component :is="getComponent" :data="data"></component>
          <div style="height: 10px; background: #000"></div>
        </el-collapse-item>
        <el-collapse-item
          name="2"
          title="事件属性"
          v-if="!['group', 'dynamic'].includes(data.type)"
        >
          <el-form-item label="change">
            <avue-input
              v-model="data.change"
              type="textarea"
              placeholder="改变事件"
              rows="5"
              clearable
            ></avue-input>
          </el-form-item>
          <el-form-item label="click">
            <el-input
              v-model="data.click"
              type="textarea"
              placeholder="点击事件"
              rows="5"
            ></el-input>
          </el-form-item>
          <el-form-item label="focus">
            <el-input
              v-model="data.focus"
              type="textarea"
              placeholder="获取焦点事件"
              rows="5"
            ></el-input>
          </el-form-item>
          <el-form-item label="blur">
            <el-input
              v-model="data.blur"
              type="textarea"
              placeholder="失去焦点事件"
              rows="5"
            ></el-input>
          </el-form-item>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <avue-empty
      v-else
      desc="拖拽字段进行配置"
      style="margin-top: 100%"
    ></avue-empty>
    <div v-if="showFieldSelectList" @click="closeLayer" style="position:fixed;top:0;left:0;width:100%;height:100%;z-index:1999;opacity:.5"></div>
  </div>
</template>

<script>
import fields from "./fieldsConfig.js";

const dateArr = [
  "year",
  "month",
  "week",
  "date",
  "datetime",
  "time",
  "daterange",
  "timerange",
  "datetimerange",
  "dates",
];
export default {
  name: "widget-config",
  props: ["data", "fieldslist", "fieldIndex", "selectFieldList", "totaloption"],
  watch: {
    fieldslist: {
      handler(val) {
        console.log("fieldslist:====>", val);
        this.fieldsDataList = this.deepClone(val);
        this.fieldsDataList_ = this.deepClone(val);
        let self = this;
      },
      deep: true,
    },
    data:{
      handler(val) {
            console.log("data=====>",val);
            this.tempComment = '';
        this.fieldsDataList_.forEach((e)=>{
          if(val.fieldId === e.id){
            this.tempComment = e.comment;
          }
          console.log();
        });
        // let self = this;
      },
      deep: true,
    },
    selectFieldList: {
      handler(val) {
        console.log("selectFieldList:====>", val);
        this.selectFieldList_ = val;
      },
      deep: true,
    },

    fieldIndex: {
      handler(val) {
        console.log("fieldIndex:====>", val);
        this.fieldIdDelete = val;
        this.fieldsDataList.forEach((e,index)=>{
          if(e.id = val){
            this.fieldsDataList[index].disabled = false;
          }
        });
      },
      deep: true,
    },
  },
  computed: {
    getComponent() {
      const prefix = "config-";
      const { type } = this.data;
      let result;
      if (["input", "password", "url"].includes(type)) result = "input";
      else if (dateArr.includes(type)) result = "date";
      else if (["array", "img"].includes(type)) result = "array";
      else result = type || "input";
      return prefix + result;
    },
    // getComment(){
    //     console.log(this.data);
    //     this.fieldsDataList_.forEach((e)=>{
    //       if(self.data.fieldId === e.id){
    //         this.tempComment = e.comment;
    //       }
    //     });
    // }
  },
  data() {
    return {
      tempComment:'',
      showFieldSelectList:false,
      fields,
      collapse: "1",
      fieldsDataList: {},
      fieldIdDelete: '',
      selectFieldList_:[]
    };
  },
  methods: {
    closeLayer(){
      this.showFieldSelectList = false;
    },
    handlerLiClick(e){
      console.log(e.target.attributes);
        if(parseInt(e.target.attributes.unclick.value)){
          this.$message.error(`"${e.target.attributes.comment.value}"不可选择`);
        this.showFieldSelectList = false;
          return;
        }
      let isRepeat = false;
      
        console.log(this.totaloption.column,e.target.attributes.fieldid.value);
      this.totaloption.column.forEach((ele,index)=>{
        if(e.target.attributes.fieldid.value === ele.fieldId){
          isRepeat = true;
          console.log('666666666666666666');

        }
      });
      if(isRepeat){
        this.$message.error('字段重复！');
        this.showFieldSelectList = false;
        return;
      }
      console.log(e.target.attributes);
      console.log(e.target.attributes.fieldid.value);
      this.tempComment = e.target.attributes.comment.value;
      this.data.fieldId = e.target.attributes.fieldid.value;
      this.showFieldSelectList = false;
      
      console.log("this.totaloption",this.totaloption);
    },
    selectFieldId(){
      this.showFieldSelectList = true;
      // this.fieldsDataList.forEach((e)=>{

      // });
    },
    getFieldLabel(fieldId){
      let fieldName = '';
      this.fieldsDataList.forEach((e)=>{
        if(e.id===fieldId){
          fieldName = e.comment;
        }
      });
      return fieldName;
    },
    handlerSelectBlur(e){
      // console.log(this.totaloption);
      // console.log('handlerSelectBlur',e.target.value);
      // console.log(e);
      // let tempIndex = 0;
      // let self = this;
      // this.fieldsDataList_.forEach((ele,index)=>{
      //   if(ele.comment===e.target.value){
      //     tempIndex = index;
      //     // self.fieldsDataList[index].disabled = true;
      //     self.selectFieldList_.push(ele);
      //     self.fieldsDataList.splice(index,1)
      //   }
      // });
      // console.log(self.fieldsDataList);
      // console.log(self.selectFieldList_);
      // // this.$emit('fieldsSelectChange',this.fieldsDataList);
      // // this.$emit('index',tempIndex);
      // // this.$emit('selectFieldList',this.selectFieldList_);
      
    },
    handlerSelectFocus(e){
      console.log("e.target.value",e.target.value);
      console.log(this.totaloption);
      console.log('handlerSelectFocus',e.target.value);
      // console.log(e);
      // let tempIndex = 0;
      // this.fieldsDataList_.forEach((ele,index)=>{
      //   if(ele.comment===e.target.value){
      //     tempIndex = index;
          
      //     self.fieldsDataList.push(ele);
      //     self.selectFieldList_.splice(index,1)
      //     // self.fieldsDataList[index].disabled = false;
      //   }
      // });
      // console.log(self.fieldsDataList);
      // console.log(self.selectFieldList_);
      // // this.$emit('fieldsSelectChange',this.fieldsDataList);
      // // this.$emit('index',tempIndex);
    },
    handlerSelectChange(val){
      console.log(this.totaloption);
      console.log(val);
      // if(this.data.fieldId){
      //   localStorage.setItem('fieldTempSelection',JSON.stringify(selection));
      //   localStorage.setItem('fieldSelectList',JSON.stringify(selectList));
      // }
    },
    async handleChangeType(type) {
      if (type) {
        const config = await this.getConfigByType(type);
        config.prop = this.data.prop;
        for (let key in config) {
          if (
            config &&
            Object.prototype.hasOwnProperty.call(config, key) &&
            !["icon", "label", "span"].includes(key)
          ) {
            const val = config[key];
            this.$set(this.data, key, val);
          }
        }
      }
    },
    getConfigByType(type) {
      return new Promise((resolve, reject) => {
        fields.forEach((field) => {
          field.list.forEach((config) => {
            if (config.type == type) resolve(config);
          });
        });
        reject();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#fieldSelectList{
  li:hover{
    background: #ddd;
  }
}
</style>
